import { taskAbilityOptions } from "@dashboard/api/queryApi";
import { useQuery } from "@tanstack/react-query";

export function useTaskAbility() {
    return useQuery(taskAbilityOptions());
}
